/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientSurveyTypeModel } from '../models/client-survey-type-model';
import { createSurveyType$Json } from '../fn/survey-type/create-survey-type-json';
import { CreateSurveyType$Json$Params } from '../fn/survey-type/create-survey-type-json';
import { createSurveyType$Plain } from '../fn/survey-type/create-survey-type-plain';
import { CreateSurveyType$Plain$Params } from '../fn/survey-type/create-survey-type-plain';
import { getSurveyType$Json } from '../fn/survey-type/get-survey-type-json';
import { GetSurveyType$Json$Params } from '../fn/survey-type/get-survey-type-json';
import { getSurveyType$Plain } from '../fn/survey-type/get-survey-type-plain';
import { GetSurveyType$Plain$Params } from '../fn/survey-type/get-survey-type-plain';
import { getSurveyTypes$Json } from '../fn/survey-type/get-survey-types-json';
import { GetSurveyTypes$Json$Params } from '../fn/survey-type/get-survey-types-json';
import { getSurveyTypes$Plain } from '../fn/survey-type/get-survey-types-plain';
import { GetSurveyTypes$Plain$Params } from '../fn/survey-type/get-survey-types-plain';

@Injectable({ providedIn: 'root' })
export class SurveyTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveyTypes()` */
  static readonly GetSurveyTypesPath = '/api/SurveyType';

  /**
   * get all surveytype.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyTypes$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyTypes$Plain$Response(params?: GetSurveyTypes$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyTypeModel>>> {
    return getSurveyTypes$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get all surveytype.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyTypes$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyTypes$Plain(params?: GetSurveyTypes$Plain$Params, context?: HttpContext): Observable<Array<ClientSurveyTypeModel>> {
    return this.getSurveyTypes$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyTypeModel>>): Array<ClientSurveyTypeModel> => r.body)
    );
  }

  /**
   * get all surveytype.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyTypes$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyTypes$Json$Response(params?: GetSurveyTypes$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyTypeModel>>> {
    return getSurveyTypes$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get all surveytype.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyTypes$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyTypes$Json(params?: GetSurveyTypes$Json$Params, context?: HttpContext): Observable<Array<ClientSurveyTypeModel>> {
    return this.getSurveyTypes$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyTypeModel>>): Array<ClientSurveyTypeModel> => r.body)
    );
  }

  /** Path part for operation `createSurveyType()` */
  static readonly CreateSurveyTypePath = '/api/SurveyType';

  /**
   * create new surveytype.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyType$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyType$Plain$Response(params?: CreateSurveyType$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyTypeModel>> {
    return createSurveyType$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * create new surveytype.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyType$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyType$Plain(params?: CreateSurveyType$Plain$Params, context?: HttpContext): Observable<ClientSurveyTypeModel> {
    return this.createSurveyType$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyTypeModel>): ClientSurveyTypeModel => r.body)
    );
  }

  /**
   * create new surveytype.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyType$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyType$Json$Response(params?: CreateSurveyType$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyTypeModel>> {
    return createSurveyType$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * create new surveytype.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyType$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyType$Json(params?: CreateSurveyType$Json$Params, context?: HttpContext): Observable<ClientSurveyTypeModel> {
    return this.createSurveyType$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyTypeModel>): ClientSurveyTypeModel => r.body)
    );
  }

  /** Path part for operation `getSurveyType()` */
  static readonly GetSurveyTypePath = '/api/SurveyType/{surveyTypeId}';

  /**
   * get surveytype by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyType$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyType$Plain$Response(params: GetSurveyType$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyTypeModel>> {
    return getSurveyType$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveytype by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyType$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyType$Plain(params: GetSurveyType$Plain$Params, context?: HttpContext): Observable<ClientSurveyTypeModel> {
    return this.getSurveyType$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyTypeModel>): ClientSurveyTypeModel => r.body)
    );
  }

  /**
   * get surveytype by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyType$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyType$Json$Response(params: GetSurveyType$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyTypeModel>> {
    return getSurveyType$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveytype by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyType$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyType$Json(params: GetSurveyType$Json$Params, context?: HttpContext): Observable<ClientSurveyTypeModel> {
    return this.getSurveyType$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyTypeModel>): ClientSurveyTypeModel => r.body)
    );
  }

}
